import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';

const drawerWidth = '70%';

const TEMPORARY = 'temporary';
const PERSISTENT = 'persistent';

const styles = () => ({
  drawerPaper: {
    width: drawerWidth,
    paddingBottom: '4em',
    display: 'inline-block',
  },
});

class SlidingModal extends Component {
  render() {
    const { classes, className } = this.props;

    return (
      <Drawer
        variant={this.props.variant}
        anchor="right"
        open={this.props.open}
        onClose={this.props.onClose}
        classes={{ paper: [classes.drawerPaper, className].join(' ') }} // so we can pass the styled-component classes from parent component
      >
        { this.props.children }
      </Drawer>
    );
  }
}

SlidingModal.propTypes = {
  open: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  onClose: PropTypes.func,
  className: PropTypes.string,
  variant: PropTypes.string,
};

SlidingModal.defaultProps = {
  open: false,
  onClose: () => {},
  className: '',
  variant: TEMPORARY,
  children: null,
};

SlidingModal.TEMPORARY = TEMPORARY;
SlidingModal.PERSISTENT = PERSISTENT;

export default withStyles(styles, { withTheme: true })(SlidingModal);
